import { GetInquiryTokenResponse } from '@/common/queries/getInquiryTokenQuery/getInquiryToken.types.ts';
import { fetchApi } from '@/config/axiosSetting';

const getInquiryTokenQueryFunction = (): Promise<GetInquiryTokenResponse> => {
  return fetchApi.post('/inquiry/user_information/authentication_inquiry/');
};

export default getInquiryTokenQueryFunction;
